import React from 'react'
import { Container } from 'typedi'
import { UserRepository } from './data/UserRepository'

const container = Container.of('app')
container.get(UserRepository)

export const ContainerContext = React.createContext(container)

export const ContainerProvider: React.FC = ({ children }) => {
  return <ContainerContext.Provider value={container}>{children}</ContainerContext.Provider>
}
